import { createContext, useContext } from 'react';

import type { TruncationMode } from '../../../../../../typography/text-ellipsis/TextEllipsis.js';
import { DEFAULT_TRUNCATION_MODE } from '../constants.js';

export const RangeLegendTruncationContext = createContext<TruncationMode>(
  DEFAULT_TRUNCATION_MODE,
);

export const useRangeLegendTruncation = () =>
  useContext(RangeLegendTruncationContext);
